import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkCheck: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark-check, add, check"><path d="M19.25 21V2.75H4.75V21L12 17L19.25 21Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.34998 10.35L11 12L14.85 8.15002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBookmarkCheck;
